import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { CodeAndDescription } from '../../../models/shared/CodeAndDescription';
import { FirmDetails } from '../../../models/check/CheckData';
import { CheckTransactionDetailsForm } from '../../../models/form/TransactionFormGroup';

@Component({
  standalone: false,
  selector: 'mm-check-address-details',
  templateUrl: './check-address-details.component.html',
  styleUrls: ['./check-address-details.component.scss']  
})
export class CheckAddressDetailsComponent implements OnInit {
  @Input() parentForm!: FormGroup<CheckTransactionDetailsForm>;
  @Input() recipient$: Observable<string>;
  @Input() defaultRecipient$: Observable<string[]>;
  @Input() stateList$: Observable<CodeAndDescription[]>;
  @Input() countryList$: Observable<CodeAndDescription[]>;
  @Input() recipientSelection$: Observable<string>;
  @Input() firmAddress: FirmDetails;
  @Input() isFromEdit$: Observable<boolean>;
  @Input() isFromCreateStandingAuth: boolean = false;
  @Input() useStandingAuth: boolean;
  @Input() shouldDisableFieldForEditQcd: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
